import { useContext } from 'react';
import PermisosContext from 'src/contexts/PermisosContext';

const usePermisos = () => useContext(PermisosContext);

export default usePermisos;
